import './AddressAutocomplete.scss'

export default class AddressAutocomplete {

    constructor($view) {

        this.view = $view;
        this.form = $view.closest('form');

        this.address = $view.find('[data-address]');
        this.postcode = $view.find('[data-postcode]');
        this.city = $view.find('[data-city]');
        this.latitude = $view.find('[data-latitude]');
        this.longitude = $view.find('[data-longitude]');
        this.search = $view.find('[data-search]');

        this.country = $view.find('[data-country]');
        this.zone = $view.find('.address-spe');

        this.bind();
    }

    bind() {
        let self = this;

        this.search.parent().css("position", "relative");

        this.search.on('blur', (e) => {
            self.search.val("");
            $(".js-autocomplete").remove();
        });

        this.search.on('keyup', (e) => {

            let value = self.search.val();

            $(".js-autocomplete").remove();


            this.doSearch({limit: 20, q: value}, (data) => {
                let autocomplete = $("<div class='js-autocomplete address-autocomplete'></div>");

                $.map(data.features, (item) => {
                    if(!(item.properties.citycode >= 97000 && item.properties.citycode <= 99000)) {
                        let formatted = self.addressFormatter(item);
                        let i = Math.floor(Math.random() * Math.floor(100000));

                        let $result = $("<a id='" + i + "'>" + formatted.label + "</a>");

                        autocomplete.append($result);

                        self.view.on("mousedown", "#" + i, (e) => {

                            this.fillAddress(formatted);

                            self.search.val('');
                            $(".js-autocomplete").remove();

                            $('.display-resume-address-infos').html(formatted.value + '<br>' + formatted.city + '<br>' + formatted.postcode);
                            $('.display-resume-address').removeClass('d-none');
                            $('.complement-address').removeClass('d-none');

                            this.view.closest('form').trigger('form:address:change');

                            this.allowSubmit();

                        });
                        return formatted;
                    }

                });

                self.search.after(autocomplete);
            });
        });

        var data = [{
            id: 'FR',
            text: '<div style="color: #9393ab;"><span class="i-fr-flag"></span> <span class="t-flag">France</span></div>',
            html: '<div><span class="i-fr-flag"></span> <span class="t-flag">France</span></div>',
            title: 'France'
        }, {
            id: 'MC',
            text: '<div style="color: #9393ab;"><span class="i-mc-flag"></span> <span class="t-flag">Monaco</span></div>',
            html: '<div><span class="i-mc-flag"></span> <span class="t-flag">Monaco</span></div>',
            title: 'Monaco'
        },  {
            id: 'SPE',
            text: '<div style="color: #9393ab;"><span class="i-spe-flag"></span> <span class="t-flag">Autre adresse française</span></div>',
            html: '<div><span class="i-spe-flag"></span> <span class="t-flag">Autre adresse française</span></div>',
            title: 'Autre adresse française'
        }];

        let $select = $('select[name="zone"]');
        if ($select.length > 0) {
            $select.select2({
                data: data,
                escapeMarkup: function(markup) {
                    return markup;
                },
                templateResult: function(data) {
                    return data.html;
                },
                templateSelection: function(data) {
                    return data.text;
                }
            });
        }

        this.zone.on('change', (e) => {
            self.displayAddress(e.currentTarget.value);
        });
        
        this.country.val('FR');

        this.address.on('change', (e) => {
            self.allowSubmit();
        });

        this.allowSubmit();

        $('.display-resume-address-icon.icon-last').on('click', (e) => {
            $('.display-resume-address').addClass('d-none');
            $('.display-spe-address').removeClass('d-none');
            this.address.removeClass('readonly');
            this.city.removeClass('readonly');
            this.postcode.removeClass('readonly');
        });

    }

    allowSubmit() {
        if (this.address.val() !== '') {
            $('.submit-address').removeClass('disabled');
        } else {
            $('.submit-address').addClass('disabled');
        }
    }

    displayAddress(zone) {
        // Gestion Api ou non
        if (zone === 'FR') {
            $('.display-spe-address').addClass('d-none');
            $('.display-search-address').removeClass('d-none');
            if (this.address.val() !== '') {
                $('.display-resume-address').removeClass('d-none');
                $('.complement-address').removeClass('d-none');
            }

            this.address.addClass('readonly');
            this.city.addClass('readonly');
            this.postcode.addClass('readonly');
        } else {
            $('.display-search-address').addClass('d-none');
            $('.display-resume-address').addClass('d-none');
            $('.display-spe-address').removeClass('d-none');
            $('.complement-address').removeClass('d-none');

            this.address.removeClass('readonly');
            this.city.removeClass('readonly');
            this.postcode.removeClass('readonly');
        }

        // Gestion Pays
        if (zone  === 'MC') {
            this.country.val('MC');
        } else {
            this.country.val('FR');
        }
    }

    fillAddress(formatted) {
        this.address.val(formatted.value);
        this.postcode.val(formatted.postcode);
        this.city.val(formatted.city);

        if (this.latitude) {
            this.latitude.val(formatted.latitude);
        }
        if (this.longitude) {
            this.longitude.val(formatted.longitude);
        }
    }

    addressFormatter(item) {
        return {
            label: item.properties.label,
            postcode: item.properties.postcode,
            citycode: item.properties.citycode,
            city: item.properties.city,
            value: item.properties.name,
            latitude: item.geometry.coordinates[1],
            longitude: item.geometry.coordinates[0]
        };
    }

    doSearch(data, successCb = () => {}, errorCb = () => {}, async = true) {
        let result = null;

        $.ajax({
            method: 'get',
            url: "https://api-adresse.data.gouv.fr/search/",
            data: data,
            dataType: "json",
            async: async,
            timeout: 3000,
            success: (data) => {
                result = successCb(data);
            },
            error: () => {
                result = errorCb();
            }
        });
        return result;
    }
}
